import { type FC, type HTMLAttributes } from 'react';
import { BoostButton } from '@components/ui/BoostButton/BoostButtton';
import {
  getMaxExpiresTimeForQuarryBoosts,
  quarryFreeBoostAvailable,
  selectTotalQuarryBoostById,
} from '@redux/selectors/quarrySelectors';
import { useAppSelector } from '@redux/store';

interface BoostQuarryButtonProps extends HTMLAttributes<HTMLButtonElement> {
  plantId: string;
}

const BoostQuarryButton: FC<BoostQuarryButtonProps> = ({
  plantId,
  ...props
}) => {
  const time = useAppSelector((state) =>
    getMaxExpiresTimeForQuarryBoosts(state, plantId),
  );
  const totalBoost = useAppSelector((state) =>
    selectTotalQuarryBoostById(state, plantId),
  );
  const isFreeBoostAvailable = useAppSelector(quarryFreeBoostAvailable);

  return (
    <BoostButton
      isFreeBoostAvailable={isFreeBoostAvailable}
      value={totalBoost || 0}
      {...props}
      {...time}
    />
  );
};

export { BoostQuarryButton };
